<!-- <link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" /> -->
<div class="k-overlay" *ngIf="editWinOpen"></div>
<div class="k-overlay" *ngIf="addWinOpen"></div>

<ng-template #windowTitleBar let-win>
  <span class="k-window-title"><span class="k-icon k-font-icon k-icon-xl k-i-form-element">
    </span> {{showTitle}}</span>
  <button kendoWindowCloseAction [window]="win"></button>
</ng-template>

<div class="card" #appendTo>

  <div class="card-header">
    Requested by: {{userStory?.requested_by_user}}
  </div>

  <div class="card-body no-border">

    <kendo-grid [kendoGridBinding]="gridData" [sort]="sort" [sortable]="true" [groupable]="true" [resizable]="true"
      [filter]="filter" filterable="menu" (filterChange)="filterChange($event)" (sortChange)="sortChange($event)"
      style="height: calc(100vh - 230px); min-height: 400px;" [pageSize]="pageSize" [pageable]="{
            buttonCount: 5,
            pageSizes: pageSizes,
            previousNext: true
          }">

      <kendo-grid-column title="View" [width]="70" [style]="vTop">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <button (click)="onEditClick(dataItem, windowTitleBar)" kendoButton class="btn btn-stn-grid">
            <fa-icon icon="magnifying-glass"></fa-icon>
          </button>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="updatedAt" format="dd-MM-yyyy HH:mm:ss" title="Updated At" [width]="170" [style]="vTop">
        <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
          let-filterService="filterService">
          <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
            [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="updated_by_user" title="Updated By" [width]="140" [style]="vTop">
        <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
          let-filterService="filterService">
          <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
            [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="project_name" title="Project" [width]="140" [style]="vTop">
        <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
          let-filterService="filterService">
          <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
            [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="title" title="Title" [width]="140" [style]="vTop">
        <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
          let-filterService="filterService">
          <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
            [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="user_story_status_description" title="Status" [width]="170" [style]="vTop">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span
            [ngStyle]="{'color': dataItem.user_story_status_description?.toLowerCase() == 'accepted' ? 'green' :
              dataItem.user_story_status_description?.toLowerCase() == 'rejected' ? 'red' :
              dataItem.user_story_status_description?.toLowerCase() == 'finished' || dataItem.user_story_status_description?.toLowerCase() == 'delivered' ? 'blue' : ''}">
            {{dataItem.user_story_status_description}}
          </span>
        </ng-template>
        <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
          let-filterService="filterService">
          <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
            [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="user_story_priority_description" title="Priority" [width]="140" [style]="vTop">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div
            [ngClass]="{'priority-low': dataItem.user_story_priority_description?.toLowerCase().indexOf('low') != -1
              , 'priority-medium': dataItem.user_story_priority_description?.toLowerCase().indexOf('medium') != -1
              , 'priority-high': dataItem.user_story_priority_description?.toLowerCase().indexOf('high') != -1
              , 'priority-critical': dataItem.user_story_priority_description?.toLowerCase().indexOf('critical') != -1 }">
            {{dataItem.user_story_priority_description}}
          </div>
        </ng-template>
        <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
          let-filterService="filterService">
          <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
            [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="user_story_type_description" title="Type" [width]="140" [style]="vTop">
        <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
          let-filterService="filterService">
          <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
            [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="user_story_estimate_description" title="Estimate" [width]="140" [style]="vTop">
        <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
          let-filterService="filterService">
          <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
            [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="owned_by_users" title="Owners" [width]="170" [style]="vTop">
        <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
          let-filterService="filterService">
          <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
            [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
        </ng-template>
      </kendo-grid-column>

      <!-- <kendo-grid-column field="requested_by_user" title="Requested By" [width]="170" [style]="vTop">
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column> -->

      <ng-template kendoGridDetailTemplate let-dataItem>

        <section>
          <p style="padding: 15px; background-color: cornsilk; font-weight:bold;"
            [innerHTML]="dataItem.description | safeHtml">
          </p>

        </section>

      </ng-template>

    </kendo-grid>

  </div>
</div>
